import Axios, { AxiosError } from "axios";
import { useMutation, useQueryClient } from "react-query";
import { caseKeys, poiKeys } from "src/query-keys";
import { APIError, Case, ImportStatus } from "src/types";

export type PoiImportMutationData = {
  poiFile: File;
};

export function usePoiImportMutation(caseId: number | string) {
  const queryClient = useQueryClient();

  async function mutationFn(caseId: number | string, data: PoiImportMutationData): Promise<void> {
    const config = {
      params: { overwrite: false },
      headers: {
        "Content-Disposition": `attachment; filename="${data.poiFile.name}"`,
      },
    };

    return Axios.put(`/planning-api/cases/${caseId}/pois/import`, data.poiFile, config);
  }
  return useMutation<void, AxiosError<APIError[]>, PoiImportMutationData, unknown>(
    (values: PoiImportMutationData) => mutationFn(caseId, values),
    {
      onSettled: async () => {
        queryClient.setQueryData<Case | undefined>(caseKeys.detail(caseId), (value) => {
          if (!value) return undefined;
          return {
            ...value,
            poiImportStatus: ImportStatus.IMPORTING,
          };
        });
        await queryClient.invalidateQueries(poiKeys.all(caseId));
      },
    }
  );
}
